export { getUserInfoServerAction } from 'next-flight-server-reference-proxy-loader?id=7fd10d1461ba2348553b40192005dcd50f0afbcb9d&name=getUserInfoServerAction!'